module.exports = __webpack_public_path__ + "img/downtime-light.7f3a8e61.svg";